<template>
    <div v-if="model.modelReady">
        <fieldset :disabled="mode == 'readonly'">
            <h2>基本信息</h2>
            <deal-and-contract :model.sync="model"
                               :extra="extra"
                               :mode="mode"
                               :updateServicePhone="updateServicePhone"
                               :errors.sync="errors">

            </deal-and-contract>
            <!-- 商品品类，按照需求文档，直连没有物流商品id：779，有需求变更改这里 -->
            <supplierProtocol
                    v-if="extra.isBD && !isTuan"
                    :extra="extra"
                    :supplierProtocolRule.sync="model.supplierProtocolRule"
                    :loaded="loaded"
                    ref='supplierProtocol'
            >
            </supplierProtocol>
            <content-block :type="{left: 2, right: 6}" title="商品品类" isRequired>
                <v-select v-va.tab1="'required'" v-model="model.mtCategory" placeholder="请选择品类" :class="{'input': true, 'is-danger': validateErrors.has('tab1', 'model.mtCategory') }">
                    <v-option v-for="item in mtCategories"
                              :label="item.label"
                              :value="item.value"
                              :key="item.value"
                              v-if="!(extra.isDirectDeal && item.value===779)"
                    >
                    </v-option>
                </v-select>
                <span v-show="validateErrors.has('tab1', 'model.mtCategory')" class="help is-danger">请选择商品品类</span>
            </content-block>
            <content-block title="景点与票种" isRequired>
                <div style="position: relative;">
                    <div class="step-line"></div>
                    <div class="row step-content">
                        <div class="ticket-step ticket-step-active col-sm-1">1</div>
                        <span class="col-sm-1 no-padding-right">选择城市</span>
                        <v-select class="col-sm-6" v-model="selectedCity" filterable placeholder="请先选择景点所在城市" >
                            <v-option v-for="item in cities"
                                      :label="item.name"
                                      :value="item.locationId"
                                      :key="item.locationId"
                            >
                            </v-option>
                        </v-select>
                    </div>
                    <div class="row step-content">
                        <div class="ticket-step ticket-step-active col-sm-1">2</div>
                        <span class="col-sm-1 no-padding-right">选择景点</span>
                        <v-select class="col-sm-6"
                                  v-model="msg"
                                  @change="clicked"
                                  filterable
                                  remote
                                  :remote-method="getPoiList"
                                  :disabled="selectedCity==='' || (onlineBefore && !extra.isBD)"
                                  :class="{'input': true, 'is-danger': validateErrors.has('tab1', 'model.ticketCategory.poi') }"
                                  :placeholder="selectedCity===''?'请选择景点':'请输入景点名称或poi编号'">
                            <v-option v-for="item in poi" :label="item.placeName" :value="item" :key="item.mdcPoiId" :disabled="item.accurateResult === 0">
                                <span class="local-gray-color" v-if="extra.isBD">{{item.mdcPoiId}}</span>
                                <b>{{item.mdcPoiName}}</b>
                                <span class="local-gray-color" v-if="extra.isBD">在售{{item.dealCount}}</span>
                            </v-option>
                        </v-select>
                        <div class="col-sm-4" v-if="extra.isBD">
                            <span class="icon-error help-icon"></span> 如若没有景点，请在CRM中先创建新景点
                        </div>
                        <div class="col-sm-4" v-else>
                            <span class="icon-error help-icon"></span> 如若没有景点，请联系你的BD
                        </div>
                    </div>
                    <span style="padding-left: 11%; margin-top: -20px;" v-show="validateErrors.has('tab1', 'model.ticketCategory.poi')" class="help is-danger">请选择景点</span>
                    <div class="row step-content tags" v-if="model.ticketCategory && model.ticketCategory.poi.length > 0">
                        <div class="col-sm-10 col-md-offset-1">
                            <v-tag
                                    v-for="(tag, index) in model.ticketCategory.poi"
                                    :closable="mode !== 'readonly' && !(onlineBefore && !extra.isBD)"
                                    :type="'success'"
                                    :key="tag.mdcPoiId"
                                    :close-transition="false"
                                    @close="handleTagClose(index)"
                                    class="tag"
                            >
                                {{tag.mdcPoiName}}
                            </v-tag>
                        </div>
                    </div>
                    <div class="row step-content tags" v-if="ticketAdvices && ticketAdvices.length > 0">
                        <div class="col-sm-10 col-md-offset-1">
                            <v-alert v-for="(advice, index) in ticketAdvices" v-html="advice.message" :key="index"
                                     class="content-gap-10mg" title=" " :type="advice.type==3?'error':'warning'">
                            </v-alert>
                        </div>
                    </div>
                    <div class="row step-content">
                        <div class="ticket-step ticket-step-active col-sm-1">3</div>
                        <span class="col-sm-1 no-padding-right">门票票种</span>
                        <v-select
                                class="col-sm-6"
                                v-va.tab1="'required'"
                                v-model="ticketType"
                                placeholder="请选择票种"
                                no-match-text="1"
                                filterable
                                :class="{'input': true, 'is-danger': validateErrors.has('tab1', 'ticketType') }"
                                :disabled="model.ticketCategory && model.ticketCategory.poi && model.ticketCategory.poi.length <= 0 || (onlineBefore && !extra.isBD)">
                            <v-option class="custom-dropdown-with-title" v-for="item in ticketTypeList"
                                      :label="item.label" :value="item.value" :key="item.value.subTicketId || item.value" :disabled="item.disabled">
                            </v-option>
                        </v-select>
                        <div class="pending-approval" v-if="ticketType && ticketType.length > 0 && (!model.ticketCategory || !model.ticketCategory.subTicket || !model.ticketCategory.subTicket.ticketId)">待审核</div>
                        <div class="col-sm-4" v-if="mode !== 'readonly'">
                            <span class="icon-error help-icon"></span> 没有合适的票种？<a @click="askForNewTicketType">申请新票种</a>
                        </div>
                    </div>
                </div>
                <span style="padding-left: 11%; margin-top: -20px;" v-show="validateErrors.has('tab1', 'ticketType')" class="help is-danger">请选择票种</span>
            </content-block>
        </fieldset>
        <fieldset :disabled="mode == 'readonly' && !isTuan">
            <content-block title="产品名称" isRequired>
                <div class="col-sm-8" style="padding-left: 0">
                    <v-input v-va.tab1="'required'" type="text" :class="{'input': true, 'is-danger': validateErrors.has('tab1', 'model.title') }" v-model="model.title" name="title" placeholder="请填写产品名称"/>
                    <span v-show="validateErrors.has('tab1', 'model.title')" class="help is-danger">请填写产品名称</span>
                </div>
                <div class="col-sm-4">
                    <span class="icon-error help-icon"></span> 格式要求：景点名称+消费项目+适用人群 例：故宫平日门票成人票
                </div>
            </content-block>
        </fieldset>
        <fieldset :disabled="mode == 'readonly'">
            <content-block v-if="ticketTypeStatusInfo && (ticketTypeStatusInfo.isNeed || ticketTypeStatusInfo.message)"
                           title="授权书">
                <span>{{ticketTypeStatusInfo.message}}</span>
                <a v-if="!extra.isBD && !extra.isDirect && certificateCreateUrl" :href="certificateCreateUrl">点此上传授权书</a>
            </content-block>
            <content-block title="费用包含" :isRequired="!extra.isDirectDeal">
                <table class="table table-hover table-bordered">
                    <thead>
                    <tr>
                        <th style="width: 30%"><span class="required-content">*</span>费用项目包含</th>
                        <th style="width: 10%"><span class="required-content">*</span>数量</th>
                        <th style="width: 10%"><span class="required-content">*</span>单位</th>
                        <th style="width: 10%">单次时长</th>
                        <th style="width: 20%">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style="cursor: default !important;" v-for="(data, index) in model.includeItems" :key="index">
                        <td>
                            <!-- 直连非必填，费用包含与补充说明二选一 -->
                            <v-input v-if="!extra.isDirectDeal" v-va.tab1="'required'" v-model="data.name" :data-key="index" placeholder="填写项目名称"/>
                            <v-input v-else @change="includeErrorCheck()" v-model="data.name" :data-key="index" placeholder="填写项目名称"/>
                        </td>
                        <td>
                            <custom-input-number :min="1" v-model="data.count"></custom-input-number>
                        </td>
                        <td>
                            <v-input v-if="!extra.isDirectDeal" v-va.tab1="'required'" :data-key="index" v-model="data.unit"/>
                            <v-input v-else @change="includeErrorCheck()" :data-key="index" v-model="data.unit"/>
                        </td>
                        <td>
                            <v-input :style="{'width': extra.isDirectDeal?'60%':'100%', 'float': extra.isDirectDeal?'left':'none'}" v-model="data.timeLength" style="display: inline-block"/>
                            <div v-if="extra.isDirectDeal" style="float: right; width: 40%; line-height: 35px">小时</div>
                        </td>
                        <td class="row">
                            <div class="col-sm-3" v-if="model.includeItems.length > 1" style="float: right">
                                    <span class="icon-times-circle control-icon delete click-able"
                                          @click="mode !== 'readonly' && deleteIncludeItems(index)"></span>
                            </div>
                            <div class="col-sm-3" style="float: right">
                                    <span class="icon-plus-circle control-icon click-able"
                                          @click="mode !== 'readonly' && newIncludeItems(index)"></span>
                            </div>
                            <div class="col-sm-3" v-if="index !== model.includeItems.length - 1" style="float: right">
                                    <span class="icon-arrow-down control-icon click-able"
                                          @click="mode !== 'readonly' && downIncludeItems(index)"></span>
                            </div>
                            <div class="col-sm-3" v-if="index !== 0" style="float: right">
                                    <span class="icon-arrow-up control-icon click-able"
                                          @click="mode !== 'readonly' && upIncludeItems(index)"></span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="table-bottom">
                    <span>项目可用数量：</span>
                    <span>
                        <label for="r21" class="label-inline"><input id="r21" name="r2" class="v-radio" type="radio"
                                                                     v-model="model.isAllAvailable" :value="true">
                            全部可用</label>
                    </span>
                    <span v-if="model.includeItems && model.includeItems.length > 1">
                        <span><input id="r22" name="r2" class="v-radio" type="radio"
                                                     v-model="model.isAllAvailable" :value="false">
                            {{model.includeItems.length}}选
                        </span>
                        <div class="nano-select inline-input" style="vertical-align: middle">
                            <custom-input-number :disabled="model.isAllAvailable" :max="model.includeItems.length-1"
                                                 :min="1" v-model="model.availableCount"></custom-input-number>
                        </div>
                        <span>&nbsp;项可用</span>
                    </span>
                </div>
                <span v-show="validateErrors.has('tab1', 'data.name') || validateErrors.has('tab1', 'data.unit')" class="help is-danger">表格包含错误</span>
            </content-block>
            <content-block title="费用包含补充说明">
                <v-input
                        v-textarea-check
                        type="textarea"
                        :rows="5"
                        class="custom-textarea"
                        v-model="model.include"
                        @change="includeErrorCheck()"
                        :maxlength="200"
                        placeholder="选填，已写在费用包含中的项目请勿重复写至本栏，否则产品可能被审核人员驳回">

                </v-input>
                <p class="help-block textarea-counter" :class="{'textarea-counter-red': model.include.length>200?true:false}">{{model.include.length}}/200字</p>
                <span class="help is-danger" style="display: none"></span>
                <span v-show="validateErrors.has('tab1', 'model.includeItems~model.include')" class="help is-danger">费用包含与补充说明二者至少填其一</span>
            </content-block>
            <content-block title="适用人群限制" v-if="!extra.isDirectDeal && model.ticketCategory.poi && model.ticketCategory.poi.length">
                <discount-des ref="crowdOption" :options="crowdOptionsMap" :extra="extra" :crowds="model.ticketPoiDiscounts" :mode="mode"></discount-des>
            </content-block>
            <content-block title="费用不包含">
                <v-input
                        v-textarea-check
                        type="textarea"
                        :rows="5"
                        class="custom-textarea"
                        :maxlength="150"
                        v-model="model.exclude"
                        placeholder="选填，需要额外花费才能享受的项目">
                </v-input>
                <p class="help-block textarea-counter" :class="{'textarea-counter-red': model.exclude.length>150?true:false}">{{model.exclude.length}}/150字</p>
                <span class="help is-danger" style="display: none"></span>
            </content-block>
            <content-block title="是否含保险" isRequired>
                <div>
                    <label for="CI1"><input id="CI1" type="radio" v-model="model.containInsurance" :value="false">
                        不包含</label>
                    <label for="CI2"><input id="CI2" type="radio" v-model="model.containInsurance" :value="true"> 包含</label>
                </div>
                <div>
                    <v-input v-va.tab1="'required'"
                             v-if="model.containInsurance"
                             v-model="model.insuranceNote"
                             :maxlength="30"
                             placeholder="请填写保险的险种以及保险公司的名称"
                             :class="{'input': true, 'is-danger': validateErrors.has('tab1','model.insuranceNote') }"/>
                    <p v-if="model.containInsurance" class="help-block input-counter">{{model.insuranceNote.length}}/30字</p>
                    <span v-show="validateErrors.has('tab1', 'model.insuranceNote', 'required')" class="help is-danger">请填写保险的险种以及保险公司的名称</span>
                </div>
            </content-block>
        </fieldset>
        <fieldset :disabled="mode == 'readonly' && !isTuan">
            <content-block title="客服电话" isRequired>
                <div class="row content-gap-10mg" v-for="(phone, index) in model.servicePhones" :key="index">
                    <div class="col-sm-3">
                        <v-input type="text" v-va.tab1="'required|tel'" :data-key="index" v-model="phone.phone" class="form-control" :class="{'input': true, 'is-danger': validateErrors.has('tab1', 'phone.phone', null, index) }" />
                        <span v-show="validateErrors.has('tab1', 'phone.phone', 'required', index)" class="help is-danger">请输入客服电话</span>
                        <span v-show="validateErrors.has('tab1', 'phone.phone', 'tel', index) && !validateErrors.has('tab1', 'phone.phone', 'required', index)" class="help is-danger">电话号码格式不正确</span>
                    </div>
                    <div class="col-sm-8">
                        客服工作时间
                        <v-select class="nano-select inline-input" v-model="phone.startHour" placeholder="请选择">
                            <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
                            </v-option>
                        </v-select>
                        点
                        <v-select class="nano-select inline-input" v-model="phone.startMin" placeholder="请选择">
                            <v-option v-for="n in 60" :label="n-1" :value="n-1" :key="n">
                            </v-option>
                        </v-select>
                        至
                        <v-select class="nano-select inline-input" v-model="phone.endHour" placeholder="请选择">
                            <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
                            </v-option>
                        </v-select>
                        点
                        <v-select class="nano-select inline-input" v-model="phone.endMin" placeholder="请选择">
                            <v-option v-for="n in 60" :label="n-1" :value="n-1" :key="n">
                            </v-option>
                        </v-select>
                        <div v-if="(mode !== 'readonly' || isTuan) && model.servicePhones && model.servicePhones.length > 1" @click="deleteOneServicePhone(index)" class="icon-button delete icon-cancel"></div>
                    </div>
                </div>
                <div class="row" v-if="(mode !== 'readonly' || isTuan) && model.servicePhones && model.servicePhones.length < 3">
                    <div class="icon-link-revise col-sm-3" v-if="servicePhone.length > 0"
                         @click="newServicePhoneFromContract">
                        <span class="icon-plus-circle"></span>
                        <span class="mls"> 从合同电话中选择</span>
                    </div>
                    <div class="icon-link-revise col-sm-3" @click="newServicePhone">
                        <span class="icon-plus-circle"></span>
                        <span class="mls"> 新增客服电话</span>
                    </div>
                </div>
            </content-block>
        </fieldset>
        <fieldset :disabled="mode == 'readonly'">
            <h2>产品图片</h2>
            <div class="row form-item">
                <div class="col-sm-2 rowTitle">产品图片</div>
                <div class="col-sm-9">
                    <div>
                        <custom-upload
                                :url="apiHost+'/midas/common/v1/upload'"
                                :is-multiple="false"
                                :max-limit="5"
                                :disabled="mode == 'readonly'"
                                :thumbnail-mode="true"
                                :show-file-list="false"
                                type="imageList"
                                :default-file-list="originImgList"
                                :fileLimitSize=2097152
                                :enable-head-image="true"
                                @on-max-limit="onMaxLimit"
                                @on-error="onError"
                                @on-success="onSuccess"
                                @on-delete="onDelete"
                                @on-file-size-max-limit="onSizeLimited"
                                @on-set-head="onSetHeadImage"
                        >
                        </custom-upload>
                    </div>
                    <div>
                        <b>注意事项：</b><br/>
                        <span style="font-size: 12px">1. 高度和宽度不低于440px，图片大小不超过2M，支持格式有jpg、png、jpeg</span><br/>
                        <span style="font-size: 12px">2. 重要提示：图片不可有字、不可使用拼图、不可有重复图片、不可有除美团水印外的其他水印、不能有人物特写、明星宣传画等涉及人物肖像权的图片</span>
                    </div>
                </div>
            </div>
        </fieldset>
        <v-dialog title="申请新票种" v-if="model.ticketCategory.createTicketCategoryInfo" v-model="dialogVisible" size="lg" :show-close="true">
            <content-block :type="{left:3,right:8}" title="票种名称" isRequired>
                <v-input v-model="model.ticketCategory.createTicketCategoryInfo.ticketCategoryName"></v-input>
            </content-block>
            <content-block :type="{left:3,right:8}" title="使用人群" isRequired>
                <v-select v-model="model.ticketCategory.createTicketCategoryInfo.usePeople" placeholder="请选择">
                    <v-option v-for="item in usePeopleTypes" :label="item.label" :value="item.value" :key="item.value">
                    </v-option>
                </v-select>
            </content-block>
            <content-block :type="{left:3,right:8}" title="时间限制范围" isRequired>
                <v-select class="col-sm-6" style="padding-left: 0" v-model="model.ticketCategory.createTicketCategoryInfo.timeLimitedRange"
                          placeholder="请选择">
                    <v-option v-for="item in timeLimitedRangeTypes" :label="item.label" :value="item.value" :key="item.value">
                    </v-option>
                </v-select>
                <v-input class="col-sm-6" style="padding-right: 0"
                         :disabled="model.ticketCategory.createTicketCategoryInfo.timeLimitedRange !== 0"
                         v-model="model.ticketCategory.createTicketCategoryInfo.timeLimitedRangeText"></v-input>
            </content-block>
            <content-block :type="{left:3,right:8}" title="票种门市价" isRequired>
                <v-input type="number" v-model="model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice"></v-input>
            </content-block>
            <content-block :type="{left:3,right:8}" title="上传物料类型" isRequired>
                <v-select v-model="model.ticketCategory.createTicketCategoryInfo.uploadMaterialType" placeholder="请选择">
                    <v-option v-for="item in uploadMaterialTypes" :label="item.label" :value="item.value" :key="item.value">
                    </v-option>
                </v-select>
            </content-block>
            <content-block :type="{left:3,right:8}" title="上传物料" isRequired
                           v-if="model.ticketCategory.createTicketCategoryInfo.uploadMaterialType !== 0">
                <v-input class="content-gap-10mg"
                         v-if="model.ticketCategory.createTicketCategoryInfo.uploadMaterialType !== 2"
                         v-model="model.ticketCategory.createTicketCategoryInfo.uploadMaterialText"
                         type="textarea"
                         :rows="2">
                </v-input>
                <custom-upload
                        :url="apiHost+'/midas/common/v1/upload'"
                        :is-multiple="false"
                        :max-limit="5"
                        :disabled="mode == 'readonly'"
                        :thumbnail-mode="true"
                        :show-file-list="false"
                        type="imageList"
                        :fileLimitSize=2097152
                        v-if="model.ticketCategory.createTicketCategoryInfo.uploadMaterialType !== 1"
                        @on-max-limit="onMaxLimit"
                        @on-error="onError"
                        @on-success="onTicketUploadSuccess"
                        @on-delete="onTicketUploadDelete"
                        @on-file-size-max-limit="onSizeLimited"
                        :default-file-list="originTicketImgList"
                >
                    <div slot="tips" class="v-upload-tips">注：高度和宽度不低于440px，图片大小不超过2M，支持格式有jpg、png、jpeg</div>
                </custom-upload>
            </content-block>
            <div v-if="model.ticketCategory.createTicketCategoryInfo.uploadMaterialType == 0" class="noUploadNotice">免物料类型：在已有的票种基础上进行使用人数变更、使用时限变更、人群组合票种变更、消费项目组合票种变更</div>
            <content-block :type="{left:3,right:8}" title=" ">
                <v-button class="btn-default" href="#" style="margin-right: 20px" @click="dialogVisible = false">关闭
                </v-button>
                <v-button class="btn-primary" href="#" @click="saveNewTicketType">申请创建票种</v-button>
            </content-block>
        </v-dialog>
        <v-dialog title="选择电话" v-model="phoneDialogVisible" size="lg" :show-close="true">
            <div v-for="(phone, index) in servicePhone" class="content-gap-10mg" :key="index">
                <label :for="`selectPhone${index}`"><input v-model="selectedPhone" :id="`selectPhone${index}`" type="checkbox" :value="phone">
                    <span>{{phone.phone}}</span>
                    <span>{{phone.startHour}}点{{phone.startMin}}分 至 {{phone.endHour}}点{{phone.endMin}}分</span>
                </label>
            </div>
            <content-block :type="{left:3,right:8}" title=" ">
                <v-button class="btn-default" href="#" style="margin-right: 10px" @click="phoneDialogVisible = false">关闭
                </v-button>
                <v-button class="btn-primary" href="#" @click="saveServicePhoneFromContract">保存</v-button>
            </content-block>
        </v-dialog>
    </div>
</template>
<style rel="stylesheet/css" lang="postcss" type="text/postcss">
    .no-fixed ul.nav-tabs {
        position: static;
    }
</style>
<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
    @media (min-width: 768px) {
        .rowTitle {
            text-align: right;
        }
    }

    .form-item {
        margin-bottom: 23px;
        line-height: 36px;
    }
    .local-gray-color {
        color: #CCC;
    }
    .ticket-step {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #d3dce6;
        display: inline-block;
        text-align: center;
        vertical-align: top;
        font-size: 14px;
        line-height: 28px;
        color: #fff;
        padding: 0 !important;
        top: 4px;
    }

    .ticket-step-active {
        background-color: #3DC6B6;
    }

    .step-line {
        height: 75%;
        position: absolute;
        border-left: dashed 2px #3DC6B6;
        left: -1px;
        top: 9%;
    }

    .step-line span, .step-line .el-select {
        margin-top: -4px;
        padding-right: 0;
    }

    .step-line .step-content:last-child {
        margin-bottom: -5px;
    }

    .step-content {
        margin-bottom: 23px;
    }

    .custom-dropdown {
        width: 100%;
    }

    .custom-dropdown-list {
        width: 42%;
        margin-left: 1%;
        border: 1px solid #3dc6b6;
    }

    .custom-dropdown-item {
        border-bottom: 1px solid ghostwhite;
        margin: 0 10px;
    }

    .custom-dropdown-item > span {
        color: #ccc;
    }

    .tags {
        margin-top: -23px;
        padding-left: 35px;
    }

    .tag {
        margin-left: 10px;
    }

    .custom-dropdown-with-title.el-select-dropdown__item.hover {
        background-color: #56c3b7;
        color: #fff;
    }

    .custom-dropdown-with-title.el-select-dropdown__item.is-disabled {
        background: #ededed;
        color: #a6a6a6;
        cursor: default;
    }

    .custom-dropdown-with-title.el-select-dropdown__item.is-disabled:hover {
        background-color: #ededed;
    }

    .custom-dropdown-with-title.el-select-dropdown__item.selected {
        background: #ffffff;
        color: #999;
    }

    .help-notice {
        margin-left: 18px;
    }

    .help-icon {
        font-size: 14px;
        color: #ff9d3c;
    }

    .control-icon {
        display: inline-block;
        font-size: 18px;
        width: 20%;
        color: #06c1ae;
    }

    .control-icon.delete {
        color: #f76120;
    }

    .table-bottom {
        width: 100%;
        height: 57px;
        border-left: 1px solid #eaeaea;
        border-right: 1px solid #eaeaea;
        border-bottom: 1px solid #eaeaea;
        padding: 10px;
    }

    .content-gap-10mg {
        margin-bottom: 10px;
    }

    .click-able {
        cursor: pointer;
    }
    .custom-textarea {
        textarea {
            line-height: 20px;
            overflow: hidden;
        }
    }
    .textarea-counter {
        float: right;
        margin-top: -30px;
        margin-right: 10px
    }
    .textarea-counter-red {
        color: #f00;
    }
    .no-padding-right {
        padding-right: 0;
    }
    .pending-approval {
        position: absolute;
        right: 45%;
        color: #f58423;
    }
    .no-padding {
        padding: 0;
    }
    .v-input__icon {
        transform: rotate(180deg);
    }
    .noUploadNotice {
        color: rgb(255, 0, 0);
        margin: -20px 0 20px 25%;
        word-wrap: break-word;
        word-break: break-all;
        padding-left: 10px;
        width: 72%;
    }
</style>

<script>
    import {
        getAllCitys,
        searchPoi,
        searchTicket,
        getTicketParenthoodAdvice,
        getCertificateValidate,
        getContractsDetail,
        getContractsDetail4BD,
        getCrowdByPoi,
        getTicketType,
        getWhitelist,
        getprotocol
    } from 'api/ticket'
    import {
        categories,
        usePeopleTypes,
        timeLimitedRangeTypes,
        uploadMaterialTypes,
        textareaForbiddenWords,
        ticketName2PersonType
    } from 'data/ticket'
    import CustomInputNumber from 'components/input-number-custom/index.vue'
    import ContentBlock from 'components/content-block/index.vue'
    import CustomUpload from 'components/custom-upload/upload.vue'
    import DiscountDes from 'components/product/discountDes.vue'
    import DealAndContract from 'components/product/dealAndContract.vue'
    import SupplierProtocol from 'components/product/supplierProtocol.vue'
    import { apiHost, otpHost } from 'config/env.conf'
    import { mapActions, mapGetters } from 'vuex'
    import { clone } from 'helpers'
    export default {
        components: {
            CustomInputNumber,
            CustomUpload,
            ContentBlock,
            DiscountDes,
            DealAndContract,
            SupplierProtocol
        },
        data () {
            return {
                apiHost,
                crowdOptionsMap: {},
                mtCategories: categories,
                usePeopleTypes,
                timeLimitedRangeTypes,
                uploadMaterialTypes,
                cities: [],
                poi: [],
                selectedCity: '',
                msg: '',
                poiname: '',
                lastTime: 0,
                ticketTypeList: [],
                ticketType: '',
                timeStr1: '',
                timeSelectVisible: false,
                dialogVisible: false,
                phoneDialogVisible: false,
                ticketAdvices: [],
                ticketTypeStatusInfo: null,
                servicePhone: [],
                selectedPhone: [],
                originImgList: [],
                originTicketImgList: [],
                onlineBefore: false,
                PAGE: 'tab1',
                poiInfo:{}
            }
        },
        props: {
            model: {
                type: Object,
                required: true
            },
            mode: {
                type: String,
                required: true
            },
            extra: {
                type: Object,
                required: true
            },
            validate: {
                type: Boolean,
                required: true
            },
            errors: {
                type: Array,
                required: true
            },
            isTuan: {
                type: Boolean,
                default: false
            },
            readonly: Boolean,
            loaded: Boolean
        },
        methods: {
            ...mapActions(['login', 'getUser']),
            ...mapGetters(['user']),
            getPoiList: async function (keyWord) {
                const startTime = new Date().getMilliseconds()
                this.lastTime = startTime
                const res = await searchPoi({
                    cityLocationId: this.selectedCity,
                    feclient: 'lvyou_web',
                    keyword: keyWord,
                    count: 20,
                    page: 1
                })
                if (startTime === this.lastTime) {
                    if (res && res.data && res.data.length && startTime === this.lastTime) {
                        this.poi = res.data
                    } else {
                        this.poi = []
                    }
                }
            },
            clicked: async function (poi) {
                if (poi) {
                    this.model.ticketCategory.poi.push(poi)
                    this.msg = ''
                    // 清空已选票种
                    this.ticketType = ''
                    await this.searchForTicketType()
                }
            },
            handleTagClose: async function (index) {
                this.model.ticketCategory.poi.splice(index, 1)
                // 清空选项
                this.ticketType = ''
                await this.searchForTicketType()
            },
            searchForTicketType: async function () {
                if (this.model.ticketCategory && this.model.ticketCategory.poi.length > 0) {
                    // 准备poi字符串
                    const searchPois = []
                    for (let i = 0; i < this.model.ticketCategory.poi.length; i++) {
                        searchPois.push(this.model.ticketCategory.poi[i].mdcPoiId)
                    }
                    const mdcPoiIds = searchPois.join(',')
                    // 父子门票接口
                    const poiNotice = await getTicketParenthoodAdvice(mdcPoiIds)
                    this.ticketAdvices = []
                    if (poiNotice && poiNotice.data && poiNotice.data.length > 0) {
                        let alertErrorMsg = ''
                        for (let i = 0; i < poiNotice.data.length; i++) {
                            this.ticketAdvices.push({
                                type: poiNotice.data[i].parentChildRelation,
                                message: poiNotice.data[i].advice
                            })
                            if (poiNotice.data[i].parentChildRelation === 3) {
                                alertErrorMsg += poiNotice.data[i].advice + "\n"
                            }
                        }
                        console.log('poiNotice error', alertErrorMsg)
                        /*
                        if (alertErrorMsg.length > 0) {
                            this.$notify.error({
                                title: '错误',
                                message: alertErrorMsg
                            });
                        }
                        */
                    }
                    // 授权书接口
                    const certificateInfo = await getCertificateValidate(mdcPoiIds, this.extra.supplierId)
                    this.ticketTypeStatusInfo = certificateInfo.data
                    if (this.ticketTypeStatusInfo.isNeed && this.ticketTypeStatusInfo.certificateInfos && this.ticketTypeStatusInfo.certificateInfos.length > 0) {
                        const poi = this.ticketTypeStatusInfo.certificateInfos[0]
                        this.certificateCreateUrl = `/#/ticket/product/list-certificate?poiId=${poi.poiId}&poiName=${encodeURIComponent(poi.poiName)}`
                    } else {
                        this.certificateCreateUrl = null
                    }
                    // 门票票种接口
                    let res = {}
                    try {
                        res = await searchTicket({
                            feclient: 'lvyou_web',
                            keyword: '',
                            mdcPoiIds
                        })
                    } catch (e) {
                        if (e.message) {
                            this.$alert({
                                title: '错误',
                                message: e.message,
                                showCancelButton: false,
                                closeOnClickModal: false
                            })
                        }
                    }

                    this.ticketTypeList = []
                    if (res && res.status === 0 && res.data && res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            this.ticketTypeList.push({
                                disabled: true,
                                label: res.data[i].name,
                                value: res.data[i].ticketId
                            })
                            if (res.data[i].subTicketCategoryInfoList && res.data[i].subTicketCategoryInfoList.length > 0) {
                                const subTicketList = res.data[i].subTicketCategoryInfoList
                                const ticketId = res.data[i].ticketId
                                const ticketName = res.data[i].name
                                for (let j = 0; j < subTicketList.length; j++) {
                                    this.ticketTypeList.push({
                                        label: subTicketList[j].name,
                                        value: {
                                            ticketId,
                                            ticketName,
                                            subTicketId: subTicketList[j].ticketId,
                                            subTicketName: subTicketList[j].name
                                        }
                                    })
                                }
                            }
                        }
                    }
                } else {
                    this.ticketAdvices = []
                }
            },
            onError: function (e) {
                this.$notify.error({
                    title: '错误',
                    message: '上传失败，请稍后重试'
                })
            },
            onSuccess: function (e) {
                this.model.dealImageInfos.push({
                    imageName: e.file.name,
                    imageUrl: e.data.data.url,
                    frontImage: false
                })
                for (let i = 0; i < this.model.dealImageInfos.length; i++) {
                    if (i===0) {
                        this.model.dealImageInfos[i].frontImage = true
                    } else {
                        this.model.dealImageInfos[i].frontImage = false
                    }
                }
            },
            onTicketUploadSuccess: function(e) {
                this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.push({
                    imageName: e.file.name,
                    imageUrl: e.data.data.url
                })
            },
            onDelete: function (e) {
                let url = ''
                if (e.file) {
                    url = e.file.url;
                } else {
                    url = e.url;
                }
                for (let i = 0; i < this.model.dealImageInfos.length; i++) {
                    if (url === this.model.dealImageInfos[i].imageUrl) {
                        this.model.dealImageInfos.splice(i, 1)
                    }
                }
            },
            onTicketUploadDelete: function (e) {
                let url = ''
                if (e.file) {
                    url = e.file.url;
                } else {
                    url = e.url;
                }
                for (let i = 0; i < this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.length; i++) {
                    if (url === this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage[i].imageUrl) {
                        this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.splice(i, 1)
                    }
                }
            },
            onMaxLimit: function (e) {
                this.$notify.error({
                    title: '错误',
                    message: '最多只能上传5张物料'
                })
            },
            onSizeLimited: function (e) {
                this.$message({
                    showClose: true,
                    message: '最多只能上传2M的物料',
                    type: 'error',
                    duration: 10000
                })
            },
            askForNewTicketType: function () {
                if (this.model.ticketCategory.poi.length > 0) {
                    this.dialogVisible = true
                }
            },
            saveNewTicketType: function () {
                // 临时的数据判断
                const createInfo = this.model.ticketCategory.createTicketCategoryInfo
                if (createInfo.ticketCategoryName.trim() === '' ||
                    createInfo.ticketCategoryPrice === '' ||
                    createInfo.ticketCategoryPrice <= 0 ||
                    (createInfo.timeLimitedRange === 0 && createInfo.timeLimitedRangeText.trim() === '') ||
                    ((createInfo.uploadMaterialType === 1 ||
                        createInfo.uploadMaterialType === 3) &&
                        createInfo.uploadMaterialText.trim() === '') ||
                    ((createInfo.uploadMaterialType === 2 ||
                        createInfo.uploadMaterialType === 3) &&
                        createInfo.uploadMaterialImage.length <=0)
                ) {
                    let message = '请将信息填写完整'
                    if (createInfo.ticketCategoryPrice <= 0 || createInfo.ticketCategoryPrice === '') {
                        message = '请输入正确的市场价'
                    }
                    this.$message({
                        showClose: true,
                        message: message,
                        type: 'error',
                        duration: 10000
                    })
                } else {
                    let decimal = createInfo.ticketCategoryPrice.toString().split('.')[1]
                    if (decimal && decimal.length > 2) {
                        this.$message({
                            showClose: true,
                            message: '请输入正确的市场价',
                            type: 'error',
                            duration: 10000
                        })
                    } else {
                        this.ticketType = createInfo.ticketCategoryName
                        let ticketName = ''
                        for (let type of usePeopleTypes) {
                            if (type.value === this.model.ticketCategory.createTicketCategoryInfo.usePeople) {
                                ticketName = type.label
                            }
                        }
                        if (!this.extra.isDirectDeal) {
                            this.initCrowdOptionsByTicketName(ticketName)
                        }
                        this.model.ticketCategory.subTicket = {}
                        this.model.ticketCategory.ticket = {}
                        this.dialogVisible = false
                        if ( !this.model.marketPrice ) {
                            this.model.marketPrice = createInfo.ticketCategoryPrice
                        }
                    }
                }
            },
            newIncludeItems: function (index) {
                this.model.includeItems.splice(index + 1, 0, {
                    name: '',
                    count: 1,
                    unit: '',
                    timeLength: null
                })
                this.model.availableCount = 1
                this.includeErrorCheck()
            },
            deleteIncludeItems: function (index) {
                this.model.includeItems.splice(index, 1)
                if (this.model.includeItems.length <= 1) {
                    this.model.isAllAvailable = true
                }
                this.model.availableCount = 1
                this.includeErrorCheck()
            },
            upIncludeItems: function (index) {
                const temp = Object.assign(this.model.includeItems[index], {})
                this.$set(this.model.includeItems, index, Object.assign(this.model.includeItems[index - 1], {}))
                this.$set(this.model.includeItems, index - 1, Object.assign(temp, {}))
            },
            downIncludeItems: function (index) {
                const temp = Object.assign(this.model.includeItems[index], {})
                this.$set(this.model.includeItems, index, Object.assign(this.model.includeItems[index + 1], {}))
                this.$set(this.model.includeItems, index + 1, Object.assign(temp, {}))
            },
            newServicePhone: function () {
                if (this.model.servicePhones.length < 3) {
                    this.model.servicePhones.push({
                        phone: '',
                        startHour: '9',
                        startMin: '0',
                        endHour: '18',
                        endMin: '0'
                    })
                }
            },
            newServicePhoneFromContract: function () {
                this.phoneDialogVisible = true
            },
            saveServicePhoneFromContract: function () {
                if (this.selectedPhone.length + this.model.servicePhones.length > 3) {
                    alert(`最多还可选${3 - this.model.servicePhones.length}个电话`)
                } else {
                    for (let i = 0; i < this.selectedPhone.length; i++) {
                        const phone = Object.assign({}, this.selectedPhone[i])
                        this.model.servicePhones.push(phone)
                    }
                    this.phoneDialogVisible = false
                }
            },
            deleteOneServicePhone: function (index) {
                this.model.servicePhones.splice(index, 1)
            },
            onSetHeadImage: function (file) {
                let index = 0
                let url = ''
                if (file.file) {
                    url = file.file.url
                } else {
                    url = file.url
                }

                for (let i = 0; i < this.model.dealImageInfos.length; i++) {
                    if (url === this.model.dealImageInfos[i].imageUrl) {
                        index = i
                    }
                    this.model.dealImageInfos[i].frontImage = false
                }
                let temp = this.model.dealImageInfos[index]
                this.model.dealImageInfos.splice(index, 1)

                this.model.dealImageInfos.unshift(temp)
                this.model.dealImageInfos[0].frontImage = true
            },
            // 更新优惠人群选项
            async updateCrowdOptions (pois = []) {
                let poiInfo = {}
                let poiIds = pois.map((poi) => {
                    poiInfo[poi.mdcPoiId] = poi
                    return poi.mdcPoiId
                })
                poiInfo.poiIds = poiIds
                this.poiInfo = poiInfo
                if (pois.length) {
                    try{
                        let { data } = await getCrowdByPoi(poiIds)
                        this.crowdOptions = data || []
                        // 初始化优惠人群数据
                        this.initTicketPoiDiscount(this.crowdOptions, poiInfo)
                    }catch(e){
                        this.crowdOptions = []
                    }
                } else {
                    this.crowdOptions = []
                }
                this.model.crowdOptions = this.crowdOptions
            },
            initTicketPoiDiscount (poiCrowdOption = [], poiInfo, poiIds) {
                let ticketPoiDiscountMap = {}
                this.model.ticketPoiDiscounts = this.model.ticketPoiDiscounts.forEach((item) => {
                    ticketPoiDiscountMap[item.mdcPoiId] = item.ticketDiscountList
                })
                this.model.ticketPoiDiscounts = poiCrowdOption.map((item) => {
                    let model = {
                        mdcPoiId: item.mdcPoiId,
                        poiName: poiInfo[item.mdcPoiId].mdcPoiName,
                        options: item.ticketDiscountList
                    }
                    if (ticketPoiDiscountMap[item.mdcPoiId] && ticketPoiDiscountMap[item.mdcPoiId].length > 0) {
                        model.ticketDiscountList = ticketPoiDiscountMap[item.mdcPoiId]
                    } else {
                        model.ticketDiscountList = [{
                            crowd: null,
                            crowdString: '',
                            otherCrowd: null,
                            discountInfo: {
                                policyType: null,
                                preventCondition: null,
                            },
                            freeInfo: {
                                policyType: 0,
                                preventCondition: null
                            }
                        }]
                    }
                    return model
                })
            },
            initCrowdOptionsByTicketName(ticketName) {
                const personTypes = ticketName2PersonType[ticketName]
                let pois = []
                for (const crowd of this.crowdOptions) {
                    pois.push(crowd.mdcPoiId)
                    let temp = {
                        mdcPoiId: crowd.mdcPoiId,
                        ticketDiscountList: []
                    }
                    let found = false
                    if (personTypes && personTypes.length > 0) {
                        for (const personType of personTypes) {
                            for (const option of crowd.ticketDiscountList) {
                                if (option.crowdString === personType && option.discountInfo.policyType !== 1) {
                                    found = true
                                    temp.ticketDiscountList.push(clone(option))
                                }
                            }
                        }
                    }
                    if (!found) {
                        temp.ticketDiscountList.push({
                            crowd: null,
                            crowdString: '',
                            otherCrowd: null,
                            discountInfo: {
                                policyType: null,
                                preventCondition: null,
                            },
                            freeInfo: {
                                policyType: 0,
                                preventCondition: null
                            }
                        })
                    }
                    this.model.ticketPoiDiscounts.push(temp)
                }
                // 准备pois数据
                this.initTicketPoiDiscount(this.crowdOptions, this.poiInfo)
            },
            includeErrorCheck() {
                // 此函数用于判断，在直连情况下，费用包含与费用包含补充说明二选其一填写
                if (this.extra.isDirectDeal) {
                    setTimeout(()=>{
                        // 首先判断是否两个都是空
                        if (this.model.include.length <=0
                            && this.model.includeItems.length===1
                            && !this.model.includeItems[0].name
                            && !this.model.includeItems[0].unit) {
                            this.validateErrors.add('tab1', {
                                key: 0,
                                modelName: 'model.includeItems~model.include',
                                showError: false,
                                rule: 'required'
                            })
                        } else {
                            this.validateErrors.removeAll('tab1', 'model.includeItems~model.include')
                            this.validateErrors.removeAll('tab1', 'data.name')
                            // 如果不是两者为空，在费用包含补充说明为空的时候，判断费用包含是否合法
                            if (this.model.include.length <=0 || this.model.includeItems.length > 1) {
                                let foundErr = false
                                for (let item of this.model.includeItems) {
                                    if (!item.name || !item.unit) {
                                        foundErr = true
                                        break
                                    }
                                }
                                if (foundErr) {
                                    this.validateErrors.add('tab1', {
                                        key: 0,
                                        modelName: 'data.name',
                                        showError: false,
                                        rule: 'required'
                                    })
                                } else {
                                    this.validateErrors.removeAll('tab1', 'data.name')
                                }
                            }
                        }
                    }, 0)
                }
            },
            updateServicePhone(servicePhone) {
                this.servicePhone = servicePhone
            },
            async updateModel() {
                // 直连初始化费用包含报错状态
                if (this.model && this.model.includeItems && this.model.includeItems.length === 0) {
                    this.model.includeItems.push({
                        name: '',
                        count: 1,
                        unit: '',
                        timeLength: null
                    })
                }

                if (this.extra.isDirectDeal) {
                    this.includeErrorCheck()
                }
                // 获取到model以后初始化
                // 初始化门票票种
                if(this.model.ticketCategory.ticket && this.model.ticketCategory.ticket.name) {
                    this.ticketType = `${this.model.ticketCategory.ticket.name} - ${this.model.ticketCategory.subTicket.name}`;
                } else if (this.model.ticketCategory.createTicketCategoryInfo && this.model.ticketCategory.createTicketCategoryInfo.ticketCategoryName) {
                    this.ticketType = this.model.ticketCategory.createTicketCategoryInfo.ticketCategoryName;
                }

                this.searchForTicketType()

                if (this.model.mtDealId) {
                    this.onlineBefore = true
                } else {
                    this.onlineBefore = false
                }

                // 初始化imglist
                this.originImgList = [];
                if (this.model.dealImageInfos.length > 0) {
                    for (let i = 0; i < this.model.dealImageInfos.length; i++) {
                        this.originImgList.push({
                            name: this.model.dealImageInfos[i].imageName,
                            url: this.model.dealImageInfos[i].imageUrl
                        })
                    }
                }

                // BD
                if (this.extra.isBD && this.extra.contractNum) {
                    try {
                        const res = await getContractsDetail4BD(this.extra.contractNum)
                        if (res && res.data && res.data.servicePhone) {
                            this.servicePhone = JSON.parse(res.data.servicePhone)
                        }
                    } catch(e) {
                        this.$Message.error({
                            content: e.message || '获取合同信息失败',
                            duration: 5
                        });
                    }
                }
                if (!this.model.ticketCategory.createTicketCategoryInfo) {
                    this.$set(this.model.ticketCategory, 'createTicketCategoryInfo', {
                        ticketCategoryName: '',
                        usePeople: 1,
                        timeLimitedRange: 3,
                        timeLimitedRangeText: '',
                        ticketCategoryPrice: '',
                        uploadMaterialType: 0,
                        uploadMaterialText: '',
                        uploadMaterialImage: []
                    })
                } else if (this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.length > 0) {
                    for (let i = 0; i < this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.length; i++) {
                        this.originTicketImgList.push({
                            name: this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage[i].imageName,
                            url: this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage[i].imageUrl
                        })
                    }
                }
            }
        },
        directives: {
            'textarea-check': function (el, binding, vnode) {
                const text = el.getElementsByTagName('textarea')[0].value
                const errorNotice = el.parentNode.getElementsByClassName('is-danger')[0]
                let findError = false
                if (errorNotice) {
                    errorNotice.style.display = 'none';
                    for (let i = 0; i< textareaForbiddenWords.length; i++) {
                        if (text.indexOf(textareaForbiddenWords[i]) !== -1) {
                            errorNotice.style.display = 'block'
                            errorNotice.innerText = '请勿在此处填写'+textareaForbiddenWords[i]+'信息'
                            findError = true
                            break
                        }
                    }
                }
                const position = vnode.context.validateErrors.search('tab1', vnode.data.model.expression, 'required')
                if (findError) {

                    if (position === -1) {
                        vnode.context.validateErrors.add('tab1', {
                            key: 0,
                            modelName: vnode.data.model.expression,
                            showError: true,
                            rule: 'required'
                        })
                    }
                } else {
                    if (position >= 0) {
                        vnode.context.validateErrors.remove('tab1', position)
                    }
                }
            }
        },
        watch: {
            selectedCity: async function () {
                await this.getPoiList('')
            },

            ticketType: async function () {
                if (typeof this.ticketType === 'object') {
                    let ticketTypeName = ''
                    if (!this.model.ticketCategory.subTicketId || !this.model.ticketCategory.ticket.subTicketId || this.ticketType.subTicketId !== this.model.ticketCategory.ticket.subTicketId) {
                        try {
                            let { data } = await getTicketType(this.ticketType.subTicketId)
                            ticketTypeName = data || ''
                        } catch (e) {
                            ticketTypeName = ''
                        }
                    }
                    this.model.ticketCategory.ticket = {
                        ticketId: this.ticketType.ticketId,
                        name: this.ticketType.ticketName
                    }
                    this.model.ticketCategory.subTicket = {
                        ticketId: this.ticketType.subTicketId,
                        name: this.ticketType.subTicketName
                    }
                    this.ticketType = `${this.model.ticketCategory.ticket.name} - ${this.model.ticketCategory.subTicket.name}`;

                    if(ticketTypeName !== '') {
                        // 放在直连判断外面，方便清洗数据
                        this.model.ticketPoiDiscounts = []
                        if (!this.extra.isDirectDeal) {
                            this.initCrowdOptionsByTicketName(ticketTypeName)
                        }
                    }
                    /*
                    if (this.$refs['crowdOption'] && this.$refs['crowdOption'].autoSelectByTicketName && ticketTypeName !== '') {
                        this.$refs['crowdOption'].autoSelectByTicketName(ticketTypeName)
                    }
                    */
                }
            },
            'model.ticketCategory.poi': async function (poi) {
                if (!this.extra.isDirectDeal) {
                    this.updateCrowdOptions(poi)
                }

                if (this.model.ticketCategory.poi.length > 0) {
                    this.validateErrors.removeAll('tab1', 'model.ticketCategory.poi')
                } else {
                    this.validateErrors.add('tab1', {
                        key: 0,
                        modelName: 'model.ticketCategory.poi',
                        showError: true,
                        rule: 'required'
                    })
                }
                if (this.extra.isBD) {
                    try {
                        let result = await getWhitelist()
                        let flag = false;
                        if (Array.isArray(result.data) && this.model.ticketCategory && this.model.ticketCategory.poi && this.model.ticketCategory.poi.length) {
                            this.model.ticketCategory.poi.forEach(i => {
                                if (result.data.includes(i.mdcPoiId)) {
                                    flag = true;
                                }
                            });
                        }
                        // poi命中演出票白名单时，展示“产品类型设置模块”
                        this.model.theatreWhiteList = flag;
                        if (!flag) {
                            this.model.ticketPriceType = 0;
                        }
                    } catch(e) {
                        this.$alert({
                            title: '错误',
                            message: e.message || '白名单获取失败',
                            showCancelButton: false,
                            closeOnClickModal: false
                        })
                    }
                }
            },
            model: async function () {
                await this.updateModel();
            }
        },
        async mounted () {
            this.errors[0] = this.validateErrors;
            const res = await getAllCitys()
            const cities = res && res.data && res.data.length > 0 ? res.data : []
            this.cities = cities
            if (this.model && this.model.includeItems && this.model.includeItems.length === 0) {
                this.model.includeItems.push({
                    name: '',
                    count: 1,
                    unit: '',
                    timeLength: null
                })
            }
            if (this.extra.isBD && this.extra.contractNum) {
                const res = await getContractsDetail4BD(this.extra.contractNum)
                if (res && res.data && res.data.servicePhone) {
                    this.servicePhone = JSON.parse(res.data.servicePhone)
                    if (this.servicePhone && this.servicePhone.length > 0 && this.model.servicePhones[0].phone === '') {
                        this.$set(this.model.servicePhones, 0, Object.assign({}, this.servicePhone[0]))
                    }
                }
                this.model.contractNum = this.extra.contractNum
                this.model.contractId = this.extra.contractId
            }
            if (!this.model.ticketCategory || !this.model.ticketCategory.poi || this.model.ticketCategory.poi.length <= 0) {
                this.validateErrors.add('tab1', {
                    key: 0,
                    modelName: 'model.ticketCategory.poi',
                    showError: false,
                    rule: 'required'
                })
            }
            this.$watch(() => {
                if (this.model && this.model.ticketCategory && this.model.ticketCategory.poi && this.model.mtCategory) {
                    let mdcPoiIds = [];
                    this.model.ticketCategory.poi.map((item, index) => {
                        mdcPoiIds.push(item.mdcPoiId)
                        return item
                    });
                    return this.model.mtCategory + mdcPoiIds.join(',')
                } else {
                    return null
                }
            }, (newVal, oldVal) => {
                if (newVal !== oldVal) {
                    this.$emit('updateMsRatio')
                }
            })
        }
    }
</script>



// WEBPACK FOOTER //
// Info.vue?2b16382f